import {
  call, put, all, select,
} from 'redux-saga/effects';

import { apiSendTask } from 'services/api/task';

import { apiGetLocals } from 'services/api/locals';

import { getErrorMessage } from 'utils/filters';

import { getTasks, getTaskByStatus } from './task';

import { getDashsInfo } from './dash';

import { Creators as FormCreators } from '../ducks/serviceForm';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';
import { Creators as LocalsCreators } from '../ducks/locals';

const fileName = 'sagas/serviceForm';

export function* finishForm({ payload: task }) {
  try {
    yield put(UiCreators.showLoader('SERVICE_FORM'));

    yield call(apiSendTask, task);

    const listFilters = yield select(state => state.task.listFilters);
    const statusFilterActived = yield select(state => state.task.statusFilterActived);
    const locals = yield call(apiGetLocals, { offset: 0, term: '' }, task.companyId);

    yield all([
      call(getDashsInfo),
      put(getTaskByStatus({ id: statusFilterActived.id, query: '', listFilters })),
      put(LocalsCreators.getLocalsSuccess(locals)),
      put(FormCreators.finishFormSuccess()),
      put(UiCreators.growl('Seu pedido foi enviado!', growlTypes.GROWL_SUCCESS)),
      put(UiCreators.hideLoader('SERVICE_FORM')),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, {
          error,
          method: `${fileName}/finishForm`,
        }),
      ),
      put(UiCreators.hideLoader('SERVICE_FORM')),
    ]);
  }
}
